module.exports = __webpack_public_path__ + "img/DE00768.f8929c25.png";